<template>
  <div id="persistent-message" v-if="message" uk-alert>
    <button class="uk-alert-close close" type="button" aria-label="Close" uk-close></button>
    <p class="message" v-html="message"></p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  message: {
    type: String,
    default: ''
  },
})
</script>

<style lang="scss" scoped>
#persistent-message {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
  color: #666;
  padding: 11.5px 34px 11.5px 11.5px; // 1行のとき40pxの高さになるように調整
  box-sizing: border-box;
  border-left: solid 3px var(--theme-color);
  border-radius: 3px;

  .close {
    top: 0;
    right: 0;
    padding: 11.8px;
  }

  .message {
    line-height: 1.4em;
    font-size: 12px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }
}
</style>
